import { Button, Fade, ListItemIcon, Menu, MenuItem, Typography } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetAppTwoTone";
import React, { useContext, useEffect, useState } from "react";
import { listConnectors } from "../api/ConnectorAPI";
import { downloadImportTemplate } from "../api/EmployeeGroupAPI";
import { AppContext } from "../context/AppContext";
import translate from "../i18n/Translator";
import { ConnectorsQueryParams, Direction, Family } from "../model/Connector";

interface CfdiIssuedPrepareMenuProps {
    anchor: HTMLElement | null;
    onClose(): any;
}

export default function CfdiIssuedPrepareMenu(props: CfdiIssuedPrepareMenuProps) {
    const context = useContext(AppContext);
    const tenantId = context.session?.tenant?.id || "-";
    const [status, setStatus] = useState("loading");
    const [employeeTemplateUrl, setEmployeeTemplateUrl] = useState<string>();

    useEffect(() => {
        setStatus("loading");
        const params = {
            search: "",
            family: Family.EMPLOYEE_GROUPS,
            direction: Direction.OUTPUT,
            includeDefault: true,
            availableForZip: false,
        } as ConnectorsQueryParams;

        listConnectors(tenantId, 0, 0, params)
            .then((response) => {
                const connector = response.items[0];
                downloadImportTemplate(tenantId, connector.id)
                    .then((url) => {
                        setEmployeeTemplateUrl(url);
                        setStatus("loaded");
                    })
                    .catch((error) => {
                        setStatus(error.message);
                    });
            })
            .catch((error) => {
                setStatus(error.message);
            });
    }, [tenantId]);

    return (
        <Menu
            id="contract-item"
            anchorEl={props.anchor}
            keepMounted
            onClose={props.onClose}
            open
            TransitionComponent={Fade}
            autoFocus={false}
            variant="selectedMenu"
        >
            {(context.isGranted("ProviderCfdisIssuedRead") || context.isGranted("TenantCfdisIssuedRead")) && (
                <Button
                    variant="text"
                    color="primary"
                    disabled={!employeeTemplateUrl && "loaded" !== status}
                    href={employeeTemplateUrl || ""}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ backgroundColor: "transparent" }}
                >
                    <MenuItem>
                        <ListItemIcon>
                            <GetAppIcon fontSize="small" color="primary" />
                        </ListItemIcon>
                        <Typography variant="body2" color="textPrimary">
                            {translate("cfdis_se.prepare.menu.download_employee_template")}
                        </Typography>
                    </MenuItem>
                </Button>
            )}
        </Menu>
    );
}
